var _rect, _rect2, _path, _rect3, _line, _line2, _circle, _line3, _line4, _ellipse, _line5, _line6, _rect4, _path2, _path3, _ellipse2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHoney(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 80,
    viewBox: "0 0 60 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 43.3334,
    width: 58.3333,
    height: 36.6667,
    rx: 5,
    fill: "#FFDC64"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.33337,
    width: 41.6667,
    height: 6.66667,
    rx: 3,
    fill: "#826469"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 18.3334C0 15.572 2.23858 13.3334 5 13.3334H53.3333C56.0948 13.3334 58.3333 15.572 58.3333 18.3334V63.3334H0V18.3334Z",
    fill: "#FDF9EC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11.6666,
    y: 33.3334,
    width: 38.3333,
    height: 26.6667,
    rx: 4,
    fill: "#6E555E"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 27.3737,
    y1: 38.3334,
    x2: 30,
    y2: 40.9596,
    stroke: "black",
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 33.2918,
    y1: 41.3777,
    x2: 35.9608,
    y2: 38.375,
    stroke: "black",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.6667,
    cy: 43.3333,
    r: 3.33333,
    fill: "#9C787E"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 25.3,
    y1: 51.2334,
    x2: 29.5667,
    y2: 48.0334,
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 1.5,
    y1: -1.5,
    x2: 6.83333,
    y2: -1.5,
    transform: "matrix(0.8 0.6 0.6 -0.8 35 45)",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.6667,
    cy: 50.8333,
    rx: 3.33333,
    ry: 5.83333,
    fill: "#FFDC64"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 28.3334,
    y1: 49.5,
    x2: 35,
    y2: 49.5,
    stroke: "black"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 28.3334,
    y1: 52.8334,
    x2: 35,
    y2: 52.8334,
    stroke: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 12.1666,
    width: 59,
    height: 67.3333,
    rx: 4.5,
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5064 14.5682C19.5769 18.9323 14.3536 20.8522 9.83978 18.8565C5.32597 16.8608 7.91021 12.6972 9.83972 8.33317C11.7692 3.9691 12.3133 1.05712 16.8272 3.05284C21.341 5.04855 23.436 10.2042 21.5064 14.5682Z",
    fill: "#826469"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2541 10.8334C47.393 6.62407 46.6647 1.48744 42.5145 3.32238C38.3643 5.15732 36.5086 10.0571 38.3697 14.2664C40.2308 18.4757 45.1039 20.4005 49.2541 18.5656C53.4042 16.7307 51.1151 15.0427 49.2541 10.8334Z",
    fill: "#826469"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.5263,
    cy: 10.1504,
    rx: 10.3759,
    ry: 8.33333,
    transform: "rotate(2.50554 29.5263 10.1504)",
    fill: "#826469"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoney);
export default __webpack_public_path__ + "static/media/honey.c33d6bcaad2203e59dfab9794093bc1d.svg";
export { ForwardRef as ReactComponent };